import { environmentVariableAPI } from '../utilities/api/environmentVariableApi';

export class APISettings {
  constructor() {
    this.getApiURL();
    this.getSearchFunctionURL();
    // this.getEnvValues();
  }

  public apiUrl: string = '';
  //TODO: we'll want to remove the blob url and have everything proxy through the api
  public static blobUrl: string = '';

  /**
   * @description return search function url
   */
  getSearchFunctionURL = () => {
    var url: string | undefined = '/search';
    var currentUrl = window.location.href;

    if (currentUrl.indexOf('localhost') !== -1) {
       url = 'https://dev-stage-ne-search.azurewebsites.net/search';


    }

    return url;
  };

  /**
   * @description returns relative path '/api' when using deployed
   * leveraging azure gateway. For localhost it will return the .env.local REACT_APP_API_URL
   * @returns URL string
   */
  getApiURL = () => {
    var url: string | undefined = '/api';
    var currentUrl = window.location.href;

    if (currentUrl.indexOf('localhost') !== -1) {
      url = process.env.REACT_APP_API_URL;
    }

    return url;
  };

  /**
   * @description returns Environment Values from .env based on the current URL
   * @returns Object
   */
  // getEnvValues = async () => {
  //   let currentUrl = window.location.hostname;
  //   let vars = (await environmentVariableAPI.getEnvironmentVariables(currentUrl)) ?? {};
  //   return vars;
  // };
}
